import React, { useCallback, useEffect, useRef, useState } from "react";
import { columns, searchBy } from "../../../service/AUUserService";
import BasicTable from "../../../Components/CommonTable/BasicTable/BasicTable";
import StoreModal from "../../../Components/Modals/StoreModal/StoreModal";
import { toast } from "react-toastify";
import { UsersApi } from "../../../App/api/users.api";
import CustomModal from "../../../custom/modal/customModal";
import CommonRejectTemplate from "../../../Components/CommonRejectTemplate";
import { approvalStatusApi } from "../../../App/api/multilevelApproval.api";
import { filters } from "./ApprovalService";

const AUUserComponent = ({ disabledFilters, pagination, handlePagination,customer }) => {
  const [search, setSearch] = useState("");
  const debounceTimeout = useRef(null);

  const [isOrderDetail, setIsOrderDetail] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState(null);
  const [vendorData, setVendorData] = useState(null);
  const [userData, setUserData] = useState(null);
  const [actionData, setActionData] = useState(null);
  const [isRejectItemModalOpen, setIsRejectItemModalOpen] = useState(false);
  const [approvalStatus, setApprovalStatus] = useState(null);

  const getAllUser = async () => {
    try {
      const res = customer?await UsersApi.getAllCustomer(pagination, search):await UsersApi.getAllVendor(pagination, search);
      setUserData(res?.data?.data);
      console.log("setUserData", res?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }

    try {
      const approvalStatus = await approvalStatusApi.getAllApprovalStatuses({
        filter: { component: "User" },
      });

      setApprovalStatus(approvalStatus?.data?.data);
    } catch (error) {
      toast.error(error?.message);
    }
  };

  const handleCellClick = async (row, action) => {
    setSelectedOrder(row);
    setIsOrderDetail(true);
    setVendorData(row);
    setActionData(action);
    if (action === "Approved") {
      setIsOrderDetail(true);
      setVendorData(row);
    } else if (
      action === "Rejected" ||
      action === "Blocked" ||
      action === "Business Off"
    ) {
      setIsRejectItemModalOpen(true);
    }
  };

  const onPaginatorClick = (e) => {
    if (e) {
      const data = {
        limit: e.rows,
        page: +e.page + 1,
      };
      handlePagination && handlePagination(data);
    }
  };

  const handleSearch = useCallback((s) => {
    setSearch(s);
  }, []);

  const debouncedSearch = useCallback(
    (s) => {
      if (debounceTimeout.current) {
        clearTimeout(debounceTimeout.current);
      }
      debounceTimeout.current = setTimeout(() => {
        handleSearch(s);
      }, 1500);
    },
    [handleSearch]
  );

  const handleClearFilter = () => {
    const clearPagination = {
      page: 1,
      limit: 5,
      sortOrder: "desc",
      filter: {},
    };
    handlePagination && handlePagination({ clearPagination });
  };
  const handleFilter = (name, value) => {
    let data = {};
    if (name === "search_by") {
      data.sortOrder = value.code;
    } else {
      const filter = {};
      filter[name] = value.code ? value.code : value;
      data.filter = filter;
    }

    handlePagination && handlePagination(data);
  };

  useEffect(() => {
    getAllUser();
  }, [pagination, search]);

  return (
    <div className="p-5">
      <BasicTable
        columns={columns}
        data={userData?.user}
        onPaginatorClick={onPaginatorClick}
        paginatorData={{
          filters: null,
          first: 0,
          multiSortMeta: [],
          page: userData?.limit || 5,
          sortField: null,
          sortOrder: null,
          totalPages: userData?.totalPages || 1,
          totalCount: userData?.totalCount || 1,
        }}
        SearchBy={searchBy}
        handleSearch={debouncedSearch}
        filters={filters}
        handleFilter={(name, value) => handleFilter(name, value)}
        handleClearFilter={handleClearFilter}
        selectedData={selectedOrder}
        handleCellClick={handleCellClick}
      />

      <StoreModal
        itemData={vendorData}
        setToggleUsersDetails={setIsOrderDetail}
        toggleUsersDetails={isOrderDetail}
        fetchAllData={getAllUser}
        approvalStatus={approvalStatus}
        component="User"

      />
      <CustomModal
        isOpen={isRejectItemModalOpen}
        onClose={() => setIsRejectItemModalOpen(false)}
        title={`${actionData} Item`}
      >
        <CommonRejectTemplate
          data={selectedOrder}
          actionData={actionData}
          name={selectedOrder?.first_name}
          getAllData={getAllUser}
          endpoint={UsersApi.approveUser}
          closeModal={setIsRejectItemModalOpen}
          component="User"
          approvalStatus={approvalStatus}
        />
      </CustomModal>
    </div>
  );
};

export default AUUserComponent;
